import React from 'react'
import { PropTypes } from 'prop-types'

import { Container } from '@sainsburys-tech/fable'

const FooterWithButton = (props) => {
  const { button } = props
  return (
    <Container className="c-footer__top-shadow">
      <div className="dsib-footerWithButton">
        <div className="dsib-footerWithButton__inner">
          {button}
        </div>
      </div>
    </Container>
  )
}

FooterWithButton.propTypes = {
  button: PropTypes.node.isRequired,
}


export default FooterWithButton
